import React from "react";
import { Carousel } from "react-bootstrap";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import Image1 from "./images/informes.jpg";
import Image2 from "./images/capacitacion.jpg";
import Image3 from "./images/image3.jpg";
import teamImage from "./img/Exterior2.png";
import Adriana from "./img/AdrianaPicacoca.png";
import Diana from "./img/DianaTorres.png";
import Elsi from "./img/ElsiSosa.png";
import Francisco from "./img/FranciscoCardozo.png";
import Jeimy from "./img/JeimySanabria.png";
import Katherin from "./img/KatherinBeltran.png";
import Olga from "./img/OlgaFranco.png";
import Oscar from "./img/OscarSuarez.png";
import Yoribe from "./img/YoribeMoreno.png";
import ClientesCarousel from "./Sides";

export const Conocenos = () => (
  <>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" />
    <link
      href="https://fonts.googleapis.com/css2?family=Aclonica&family=DynaPuff:wght@400..700&family=Righteous&family=Rozha+One&display=swap"
      rel="stylesheet"
    />

    <div className="background">
      <Carousel
        className="carousel"
        interval={3000}
        controls={true}
        indicators={false}
      >
        <Carousel.Item>
          <img src={Image1} alt="" className="full-background-image" />
        </Carousel.Item>
        <Carousel.Item>
          <img src={Image2} alt="" className="full-background-image" />
        </Carousel.Item>
        <Carousel.Item>
          <img src={Image3} alt="" className="full-background-image" />
        </Carousel.Item>
      </Carousel>

      <div className="navbar fw-bolder" style={{ backgroundColor: "#003366" }}>
        <div className="">
          <a href="/">Inicio</a>
          <a href="/Conocenos">Conócenos</a>
          <a href="/#servicios">Servicios</a>
          <a href="/#footer">Contacto</a>
          <a href="/#noticias">Noticias</a>
          <a href="/#herramientas">Herramientas</a>
          <a href="/login" className="login-button">
            Iniciar sesión
          </a>
        </div>
        <div className="social-icons">
          <a href="tel:+5731644483635">
            <i className="fa fa-phone"></i>
          </a>
          <a href="https://www.facebook.com/SISTEMAROCKYSAS">
            <i className="fa-brands fa-whatsapp"></i>
          </a>
          <a href="https://www.instagram.com/rockysas2023/">
            <i className="fa-brands fa-instagram"></i>
          </a>
        </div>
      </div>

      <div className="logo-container">
        <h1 className="logo">Rocky</h1>
        <p className="subtitle">Sistema de información en atención primaria S.A.S</p>
      </div>

      <a href="https://wa.me/573112378357" className="whatsapp">
        ¿Necesitas ayuda?
      </a>
    </div>
    <br />
    {/* "Inicio" Section */}
    <div
      id="servicios"
      className="servicios-section"
    >
      <h2
        style={{
          fontFamily: "Righteous, sans-serif",
          fontSize: "4em",
          background: "( #003366)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          color: "transparent",
        }}
      >
        Conócenos
      </h2>
      <div className="row d-flex justify-content-center">
        <div className="col-lg-6">
          <div className="card">
            <div className="">
              <div className="servicio-item1">
                <p>
                  La empresa SISTEMA DE INFORMACIÓN EN ATENCIÓN EN SALUD ROCKY,
                  ha basado su EXPERIENCIA en el diseño, desarrollo e
                  implementación de soluciones de software para el sector Salud,
                  venta De Sistema De Información En Salud para las
                  Instituciones Prestadoras de Salud de Primer Nivel en lo
                  referente al suministro, actualización y soporte Técnico,
                  Auditoria Integral de Cuentas Medicas, Auditoria de Calidad,
                  Capacitaciones, Revisión, Generación, Validación y Cargue de
                  Informes a los Diferentes Entes de Control, Revisión de los
                  procesos de Facturación, Suministro de Computadores,
                  Servidores, Instalación y mantenimiento De Redes. Cuenta con
                  el respaldo de más de 115 Instituciones prestadoras de Salud
                  como clientes en todo el departamento de Boyacá, Santander,
                  Cesar y Sur de Bolívar, las cuales son la garantía que nos
                  permite seguir creciendo, ofreciendo un servicio profesional
                  de alta calidad, serio y eficiente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="servicios" className="servicios-section">
        <div className="servicios-grid">
          <div className="servicio-item2">
            <h3>
              Misión <i className="fa-solid fa-pencil"></i>
            </h3>

            <p>
              La empresa Rocky busca con el desarrollo e implementación del
              Software mejorar la calidad de la Información de los servicios de
              Salud en las IPS de primer Nivel, utilizando una tecnología
              apropiada, fácil de entender y manejar, valorando el talento
              Humano y compromiso de su equipo de trabajo, manteniendo nuestros
              principios y siendo sostenibles, basados en la calidad,
              eficiencia, seguridad y confiabilidad de la Información.
            </p>
          </div>
          <div className="servicio-item2">
            <h3>
              Visión <i className="fa-solid fa-binoculars"></i>
            </h3>
            Rocky como empresa se ve posicionada para el año 2023, como una
            Empresa líder, reconocida principalmente por las IPS de primer Nivel
            del departamento de Boyacá y porque no en los demás departamentos,
            ya que nuestro software brinda calidad, fácil manejo, seguridad en
            su información, ayudado por el soporte y capacitación brindado
            eficazmente por el trabajo en equipo cumpliendo con las expectativas
            de nuestros clientes, aportando en el desarrollo, crecimiento,
            estabilidad y funcionamiento de los procesos de Calidad de Cada IPS.
          </div>
        </div>
      </div>
    </div>

    <ClientesCarousel />
    {/* <section className="sectionClaro">
        <div className="titulos">
            <h2>NUESTROS CLIENTES</h2>
            <p>Nuestra familia Rocky</p>
        </div>

        <div className="flexslider slideClientes">
            <ul className="slides">
                <li className="slide_card">
                    <div className="contenedorSec">
                        <div className="articulos clientesArt">
                            <article><img src="/assets/ips/Aguada - santander.png" alt=""/></article>
                            <article><img src="/assets/ips/albania - santander.png" alt=""/></article>
                            <article><img src="/assets/ips/bolivar - santander.png" alt=""/></article>
                            <article><img src="/assets/ips/cepita - santander.png" alt=""/></article>
                            <article><img src="/assets/ips/chipata - santander.png" alt=""/></article>
                            <article><img src="/assets/ips/coromoro - santander.png" alt=""/></article>
                            <article><img src="/assets/ips/elPayon - Santander.png" alt=""/></article>
                            <article><img src="/assets/ips/encino - Santander.png" alt=""/></article>
                            <article><img src="/assets/ips/Forian - Santander.png" alt=""/></article>
                            <article><img src="/assets/ips/guavata - santander.png" alt=""/></article>
                        </div>
                    </div>
                </li>
                <li className="slide_card">
                    <div className="contenedorSec">
                        <div className="articulos clientesArt">
                            <article><img src="/assets/ips/laBelleza - santander.png" alt=""/></article>
                            <article><img src="/assets/ips/laPaz - Santander.png" alt=""/></article>
                            <article><img src="/assets/ips/matanza - santander.png" alt=""/></article>
                            <article><img src="/assets/ips/suaita - santander.png" alt=""/></article>
                            <article><img src="/assets/ips/aquitania - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/belen - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/berbeo - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/beteitiva - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/borbur - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/boyaca - boyaca.png" alt=""/></article>
                        </div>
                    </div>
                </li>
                <li className="slide_card">
                    <div className="contenedorSec">
                        <div className="articulos clientesArt">
                            <article><img src="/assets/ips/campoHermoso - Boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/cerinza - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/chiquiza - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/chitaraque - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/chivata - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/cienega - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/combita - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/CONFINES - BOAYCA.png" alt=""/></article>
                            <article><img src="/assets/ips/coper - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/cubara - boyaca.png" alt=""/></article>
                        </div>
                    </div>
                </li>
                <li className="slide_card">
                    <div className="contenedorSec">
                        <div className="articulos clientesArt">
                            <article><img src="/assets/ips/cucaita - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/cuitiva - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/elCocuy - Boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/firavitoba - Boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/floresta - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/gameza - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/iza - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/jenesano - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/jerico - Boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/labranzaGrande - boyaca.png" alt=""/></article>
                        </div>
                    </div>
                </li>
                <li className="slide_card">
                    <div className="contenedorSec">
                        <div className="articulos clientesArt">
                            <article><img src="/assets/ips/laCapilla - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/laUvita - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/macanal - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/Mongua - Boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/muzo - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/Nobsa - Boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/nuevoColon - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/oicata - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/otanche - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/pachavita - boyaca.png" alt=""/></article>
                        </div>
                    </div>
                </li>
                <li className="slide_card">
                    <div className="contenedorSec">
                        <div className="articulos clientesArt">
                            <article><img src="/assets/ips/paez - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/pajarito - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/Pauna - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/Paya - Boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/pesca - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/pisba - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/quipama - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/ramiriqui - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/Raquira - Boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/sachica - boyaca.png" alt=""/></article>
                        </div>
                    </div>
                </li>
                <li className="slide_card">
                    <div className="contenedorSec">
                        <div className="articulos clientesArt">
                            <article><img src="/assets/ips/samaca - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/santana - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/santaSofia - Boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/siachoque - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/socha - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/socota - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/somondoco - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/sotaquira - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/surata - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/susacon - boyaca.png" alt=""/></article>
                        </div>
                    </div>
                </li>
                <li className="slide_card">
                    <div className="contenedorSec">
                        <div className="articulos clientesArt">
                            <article><img src="/assets/ips/sutamarchan - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/tibana - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/tibasosa - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/tinjaca - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/toca - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/Togui - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/topaga - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/tota - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/turmeque - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/tuta - boyaca.png" alt=""/></article>
                        </div>
                    </div>
                </li>
                <li className="slide_card">
                    <div className="contenedorSec">
                        <div className="articulos clientesArt">
                            <article><img src="/assets/ips/umbita - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/viracacha - boyaca.png" alt=""/></article>
                            <article><img src="/assets/ips/morales - Bolivar.png" alt=""/></article>
                            <article><img src="/assets/ips/Gamarra - Cesar.png" alt=""/></article>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        
    </section> */}
    <br />
    <div className="row d-flex justify-content-center">
      <div className="sections">
        <h2 className="fw-bold" style={{
          fontFamily: "Righteous, sans-serif",
          fontSize: "4em",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          color: "transparent",
        }}>Nuestro equipo</h2>
      </div>
      <img className="Exterior" src={teamImage} alt="foto de todo el team" />

      <div className="col-lg-2 team-member">
        <img className="Integrantes" src={Francisco} alt="foto de Francisco" />
        <h4 className="member-name">Dr. Francisco Javier Cardozo</h4>
        <h4 className="member-position">Gerente</h4>
        <h4 className="member-department">Administrativo</h4>
      </div>
      <div className="col-lg-2 team-member">
        <img className="Integrantes" src={Elsi} alt="foto de Elsi" />
        <h4 className="member-name">Ing. Elsi Yohana Sosa</h4>
        <h4 className="member-position">Supervisora</h4>
        <h4 className="member-department">Administrativo</h4>
      </div>
      <div className="col-lg-2 team-member">
        <img className="Integrantes" src={Jeimy} alt="foto de Jeimy" />
        <h4 className="member-name">Jeimy Muñoz Sanabria</h4>
        <h4 className="member-position">Supervisora</h4>
        <h4 className="member-department">Informes</h4>
      </div>
      <div className="col-lg-2 team-member">
        <img className="Integrantes" src={Olga} alt="foto de Olga" />
        <h4 className="member-name">Olga Marlen Franco</h4>
        <h4 className="member-position">Supervisora</h4>
        <h4 className="member-department">Auditoria y Radicación</h4>
      </div>
      <div className="col-lg-2 team-member">
        <img className="Integrantes" src={Adriana} alt="foto de Adriana" />
        <h4 className="member-name">Adriana Niño Ramos</h4>
        <h4 className="member-position">Supervisora</h4>
        <h4 className="member-department">Soporte tecnico </h4>
      </div>
      <div className="col-lg-2 team-member">
        <img className="Integrantes" src={Oscar} alt="foto de Oscar" />
        <h4 className="member-name">Ing. Oscar Leonardo Suarez </h4>
        <h4 className="member-position">Supervisor</h4>
        <h4 className="member-department">Desarrollo</h4>
      </div>
      <div className="col-lg-2 team-member">
        <img className="Integrantes" src={Yoribe} alt="foto de Yoribe" />
        <h4 className="member-name">Yoribe Andrea Moreno </h4>
        <h4 className="member-position">Supervisora</h4>
        <h4 className="member-department">Capacitación</h4>
      </div>
      <div className="col-lg-2 team-member">
        <img className="Integrantes" src={Diana} alt="foto de Diana" />
        <h4 className="member-name">Diana Geraldine Torres</h4>
        <h4 className="member-position">Coordinadora</h4>
        <h4 className="member-department">Informes</h4>
      </div>
      <div className="col-lg-2 team-member">
        <img className="Integrantes" src={Adriana} alt="foto de Adriana" />
        <h4 className="member-name">Adriana Yasmin Piracoca </h4>
        <h4 className="member-position">Coordinadora</h4>
        <h4 className="member-department">Informes</h4>
      </div>
      <div className="col-lg-2 team-member">
        <img className="Integrantes" src={Katherin} alt="foto de Katherin" />
        <h4 className="member-name">Katherin Beltran Guerrero</h4>
        <h4 className="member-position">Coordinadora</h4>
        <h4 className="member-department">Auditoria y Radicación</h4>
      </div>
    </div>

    <div className="footer">
      <div className="footer-column">
        <h2>Rocky</h2>
        <div className="footer-text">
          <p>Sistema de información en atención primaria S.A.S</p>
        </div>
        <div className="footer-social-icons">
          <a href="https://wa.me/573112378357" className="fs-5 text-decoration-none">
            <i className="fa-brands fa-whatsapp"></i>
          </a>
          <br />
          <a href="https://www.facebook.com/SISTEMAROCKYSAS" className="fs-5 text-decoration-none">
            <i className="fa-brands fa-instagram"></i>
          </a>
        </div>
      </div>
      <div className="footer-column">
        <h2>Servicios</h2>
        <div className="footer-text">
          <ul>
            <li>Sistemas de información en salud</li>
            <li>Auditoria integral en salud</li>
            <li>Informes para entes de control (EPS)</li>
            <li>Preauditoria y Radicación de cuentas médicas</li>
            <li>Auditoría, procesos de cartera y contratación</li>
            <li>Suministro de equipos de cómputo</li>
            <li>Soporte técnico</li>
            <li>Rocky Learn (Procesos educativos)</li>
            <li>Instalación y mantenimiento de redes</li>
          </ul>
        </div>
      </div>
      <div className="footer-column">
        <h2>Sedes</h2>
        <div className="footer-text">
          <p>
            <strong>Carrera 8 N 54A - 04Prados del norte</strong>
          </p>
          <p>
            <strong>(Tunja - Boyacá)</strong>
          </p>
        </div>
      </div>
      <div className="footer-column">
        <h2>Contáctanos</h2>
        <div className="footer-text">
          <p>Tu opinión es importante...</p>
          <p>
            <i className="fa fa-phone"></i> (+57) 311 237 8357
          </p>
          <p>
            <i className="fa fa-envelope"></i> sistemarocky@hotmail.com
          </p>
        </div>
      </div>
    </div>
    <style>{`
        /* Reset */
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
         /* Animaciones */
        @keyframes slideIn {
          from { transform: translateY(-100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes navbarSlideIn {
          from { transform: translateY(-50px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
  .background {
          position: relative;
          height: 100vh;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
  
  .Exterior{
  width: 100%; 
  height: auto;  
  }

  .full-background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
  .carousel {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: -1;
        }

  .Integrantes {
    width: 150px;
    height: 150px; 
    border-radius: 50%;
    border: 3px solid #005cbf;
    object-fit: cover;
    margin: 10px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;}

  .Integrantes:hover {
    transform: scale(1.1); /* Aumenta el tamaño de la imagen al pasar el cursor */
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* Añade sombra */
  }
  .team-member {
    text-align: center;
    margin: 20px;
}

  .member-name {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-top: 10px;
  }

  .member-position {
      font-size: 14px;
      font-weight: bold;
      color: #005cbf;
      margin: 5px 0;
  }

  .member-department {
      font-size: 14px;
      color: #666;
  }
  
  .navbar {
          position: fixed;
          top: 0;
          width: 100%;
          display: flex;
          justify-content: space-around;
          padding: 25px;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 1000;
        }

  .navbar a { color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; }
  .navbar a:hover { background-color: #ffeb3b; color: #003366 }
  
          .inicio-section, .servicios-section {
          padding: 0px 70px;
          text-align: center;
          color: #333;
          height: 60vh;
        }

        .servicios-section h2 {
  font-family: 'Righteous', sans-serif;
  font-size: 2.5em;
  background: linear-gradient(90deg, #0000FF, #FFFF00); /* Degradado de azul a amarillo */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; /* Asegura que el texto sea transparente en Safari y Chrome */
  color: transparent; /* Hace el texto transparente para ver el degradado */
}

        .servicios-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
          margin-top: 10px;
        }

        .servicios-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px;
}
        .text{
        color: black;
        text-align: center;
        }
        .tittle{
        color: #003366;
        text-align: center;


        }

        .servicio-item1 {
          background-color: #003366;
          color: #ffffff;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }
        .servicio-item2 {
          background-color: #003366;
          color: #ffffff;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }

        .servicio-item2 h3 { color: #dabf5c; }
        .servicio-item1 h3 { color: #dabf5c; }

        .logo-container {
          text-align: center;
          animation: fadeIn 1s ease-in-out;
        }

      .logo {  font-family: "Righteous", serif;
        font-weight: 400;
        font-style: normal;font-size: 10em;color : #dabf5c}

      .subtitle { font-size: 2em; font-family: "Righteous", sans-serif; }
.subtitle {
  font-size: 5em;
  font-family: "Righteous", sans-serif;
  color: #003366;
  text-align: center;
  text-shadow: 
    -1px -1px 0 #ffffff,  
    1px -1px 0 #ffffff,  
    -1px 1px 0 #ffffff,  
    1px 1px 0 #ffffff;
}
        .social-icons {
          position: absolute;
          top: 17px;
          right: 10px;
          display: flex;
          gap: 10px;
        }
        
        .social-icons a {
          color: black;
          background-color: white;
          border-radius: 50%;
          padding: 10px;
          text-decoration: none;
          font-size: 1.2em;
          display: inline-flex;
          justify-content: center;
          align-items: center;
        }

        .whatsapp {
          position: fixed;
          bottom: 20px;
          right: 20px;
          background-color: #25D366;
          color: white;
          padding: 10px 15px;
          border-radius: 50px;
          font-weight: bold;
        }

        .footer { background-color: #003366; color: #dabf5c; display: flex; justify-content: space-around; padding: 20px; }
        .footer-text {color: white}
        .footer-column { padding: 20px; }
        .footer-column h2 { border-bottom: 1px solid #fff; padding-bottom: 10px; }
        .footer-social-icons a { color: white; }        
`}</style>
  </>
);
